export default [
    {
        path: 'denuncias',
        component: require('./Read').default,
        meta: { middleware: 'auth', controller: 'DenunciaController' }
    }, ,
    {
        path: 'denuncias/edit/:id',
        component: require('./Edit').default,
        meta: { middleware: 'auth', controller: 'DenunciaController' },
    },
    {
        path: 'denuncias/show/:id',
        component: require('./Show').default,
        meta: {
            middleware: 'auth',
            controller: 'DenunciaController'
        }
    },

    {
        path: 'relatorios/denuncias',
        component: require('./reports/Reports').default,
        redirect: 'relatorios/denuncias/home',
        meta: { middleware: 'auth', controller: 'RelatorioDenunciaController' },
        children: [{
            path: 'home',
            name: 'relatorios_home_denuncias',
            component: require('./reports/includes/Home').default,
            meta: { middleware: 'auth', controller: 'RelatorioDenunciaController' },
        }, {
            path: 'graficos',
            name: 'graficos_denuncias',
            component: require('./reports/includes/Graficos').default,
            meta: { middleware: 'auth', controller: 'RelatorioDenunciaController' },
        }
        ]
    }
];


